import React, { useState } from "react";
import Slider from "react-slick";
import {
  animation,
  animation1,
  animation2,
  expertbg,
  expertbg1,
  expertbg2,
  expertdetails,
  expertdetails1,
  expertdetails2,
  expertdetails3,
  expertdetails4,
  expertdetails5,
  expertdetails6,
  expertdetails7,
  features1,
  features2,
  features3,
  features4,
  healthmeter,
  healthmeter1,
  healthmeter2,
  totalcare,
  totalcare1,
  totalcare2,
} from "../../assets/images";
import "./aboutus.scss";
import { Helmet } from "react-helmet";

const AboutUs = () => {
  // const Array = [1, 2, 3, 4, 5];
  const settings = {
    dots: false,
    fade: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 4000,
    // waitForAnimate: false,
  };

  const [activeIndex, setActiveIndex] = useState(1);
  // console.log("activeIndex", activeIndex);
  const blogList = [
    {
      id: 1,
      title: "Pcos",
      Description:
        "PCOS, a leading cause of infertility, can be effectively managed through targeted lifestyle adjustments, appropriate medications, and consistent health monitoring.",
      img: features1,
    },
    {
      id: 2,
      title: "Endometriosis",
      Description:
        "Endometriosis, a significant cause of infertility, can be effectively managed through lifestyle changes, medical treatments, and regular monitoring.",
      img: features2,
    },
    {
      id: 3,
      title: "Postpartum",
      Description:
        "Postpartum challenges, including recovery and emotional well-being, can be effectively managed with lifestyle adjustments, medical support, and consistent care.",
      img: features3,
    },
    {
      id: 4,
      title: " Menopause",
      Description:
        "Menopause, a natural transition in life, can be effectively managed through lifestyle adaptations, medical guidance, and regular health monitoring.",
      img: features4,
    },
  ];

  // const orgnaizationData = {
  //   "@context": "https://schema.org",

  //   "@type": "MedicalOrganization",

  //   name: "Holypills",

  //   alternateName: "Holypills Homeopathy Platform",

  //   url: "https://www.holypills.in",

  //   logo: "https://holypills.in/static/media/logoblk.85a98ca03ea02020c9410dbb9412a5f5.svg",

  //   image: "https://www.holypills.in/banner.jpg",

  //   description:
  //     "Holypills is a trusted homeopathy care platform for women’s health. From PCOS and Endometriosis to Menopause and Postpartum recovery, we provide personalized remedies and app-based tracking to help you heal naturally.",

  //   founder: {
  //     "@type": "Person",

  //     name: "Dr. Ila Kathuria",

  //     jobTitle: "Co-Founder & Chief Homeopathy Consultant",

  //     image:
  //       "https://holypills.in/static/media/founder.643f6d9fcb22ed9aaddd.jpeg",

  //     description:
  //       "Dr. Ila Kathuria, a distinguished name in women’s health and one of India’s foremost advocates of personalized, integrative care. With over 35 years of clinical experience, Dr. Kathuria has consistently challenged the status quo in women’s healthcare by blending the depth of homeopathy with the precision of modern medical insight.",
  //   },

  //   foundingDate: "2025",

  //   sameAs: [
  //     "https://www.facebook.com/holypillscare",

  //     "https://www.instagram.com/holypillscare",

  //     "https://www.linkedin.com/company/holypillscare",

  //     "https://www.youtube.com/@Holypillscare",
  //   ],

  //   contactPoint: {
  //     "@type": "ContactPoint",

  //     telephone: "+91-9999887833",

  //     contactType: "customer service",

  //     availableLanguage: ["English", "Hindi"],
  //   },

  //   address: {
  //     "@type": "PostalAddress",

  //     streetAddress:
  //       "Connaught Place 4 - S, DCM Building Barakhamba Road, Landmark: Near Metro Station, Delhi, Delhi",

  //     addressLocality: "Delhi",

  //     addressRegion: "Delhi",

  //     postalCode: "110001",

  //     addressCountry: "IN",
  //   },
  // };

   const schemaData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "MedicalOrganization",
        "@id": "https://holypills.in/#organization",
        name: "Holypills",
        url: "https://holypills.in/",
        logo: "https://holypills.in/blog/wp-content/uploads/2025/07/logo-holypills.png",
        sameAs: [
          "https://www.facebook.com/holypillscare/",
          "https://www.x.com/holypillscare",
          "https://www.instagram.com/holypillscare",
          "https://www.youtube.com/@Holypillscare",
          "https://www.linkedin.com/company/holypillscare/",
          "https://holypills.in/",
        ],
        department: [
          {
            "@type": "MedicalBusiness",
            "@id": "https://holypills.in/#noida-location",
            name: "Holypills Noida",
            url: "https://holypills.in/",
            telephone: "+91 9999887833",
            address: {
              "@type": "PostalAddress",
              streetAddress:
                "UGF-4, P6, Ocean Complex Sector - 18, Opposite GIP Mall",
              addressLocality: "Noida",
              addressRegion: "UP",
              postalCode: "201301",
              addressCountry: "IN",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: "28.582598219375473",
              longitude: "77.32425561144417",
            },
          },
          {
            "@type": "MedicalBusiness",
            "@id": "https://holypills.in/#delhi-location",
            name: "Holypills Delhi",
            url: "https://holypills.in/",
            telephone: "+91 9990709586",
            address: {
              "@type": "PostalAddress",
              streetAddress:
                "Connaught Place 4 - S, DCM Building, Barakhamba Road",
              addressLocality: "Delhi",
              addressRegion: "Delhi",
              postalCode: "110001",
              addressCountry: "IN",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: "28.63002133140495",
              longitude: "77.22458600938388",
            },
          },
        ],
      },
      {
        "@type": "Physician",
        "@id": "https://holypills.in/#dr-ila-kathuria",
        name: "Dr. Ila Kathuria",
        gender: "Female",
        image:
          "https://holypills.in/blog/wp-content/uploads/2025/11/Dr-Ila-.webp",
        url: "https://holypills.in/doctors-details/dr-ila-kathuria",
        worksFor: { "@id": "https://holypills.in/#organization" },
        medicalSpecialty: [
          "Homeopathy",
          "PCOS treatment",
          "Endometriosis Treatment",
          "Menopause Treatment",
          "Postpartum Treatment",
          "Holistic Healing",
        ],
        sameAs: [
          "https://www.facebook.com/drila.kathuria/",
          "https://x.com/DrKathuria283",
          "https://www.linkedin.com/in/ila-kathuria-710941370/",
          "https://holypills.in/doctors-details/dr-ila-kathuria",
        ],
      },
    ],
  };

  return (
    <>
      <Helmet defer={false}>
        <title>
          Holypills – Your Online Homeopathy Partner for Holistic Healing
        </title>
        <meta
          name="description"
          content="Holypills is a trusted homeopathy care platform for women’s health. From PCOS and Endometriosis to Menopause and Postpartum recovery, we provide personalized remedies and app-based tracking to help you heal naturally."
        />
        <meta property="og:image" content="/src/assets/images/ogImage.jpg" />
        <meta name="twitter:image" content="/src/assets/images/ogImage.jpg" />
        <link rel="canonical" href="https://holypills.in/about-us" />

        <meta property="og:type" content="article" />
        <meta
          property="og:title"
          content=" Holypills – Your Online Homeopathy Partner for Holistic Healing"
        />
        <meta
          property="og:description"
          content="Holypills is a trusted homeopathy care platform for women’s health. From PCOS and Endometriosis to Menopause and Postpartum recovery, we provide personalized remedies and app-based tracking to help you heal naturally."
        />

        <meta property="og:url" content="https://holypills.in/about-us" />
        <meta property="og:site_name" content="Holypills"></meta>

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content=" Holypills – Your Online Homeopathy Partner for Holistic Healing"
        />
        <meta
          name="twitter:description"
          content="Holypills is a trusted homeopathy care platform for women’s health. From PCOS and Endometriosis to Menopause and Postpartum recovery, we provide personalized remedies and app-based tracking to help you heal naturally."
        />

        <meta name="twitter:url" content="https://holypills.in/about-us"></meta>
        {/* <script type="application/ld+json">
          {JSON.stringify(orgnaizationData)}
        </script> */}
        <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
      </Helmet>

      <div className="wrapper_about_us_page wrapper_pcos_page " id="whyUs">
        <section className="wrap_bg_slider spacing">
          <div className="cnt_fixed">
            <p>Why HolyPills</p>
            <h1>Your Trusted Partner in Women's Health</h1>
            <p>
              Expert care, personalized for you. Get the right support for PCOS,
              Endometriosis, Menopause, and Postpartum health—all from the
              comfort of your home.
            </p>
          </div>
          <Slider {...settings}>
            <div className="wrap_img">
              <img src={animation} alt="slider-img" />
            </div>
            <div className="wrap_img">
              <img src={animation1} alt="slider-img" />
            </div>
            <div className="wrap_img">
              <img src={animation2} alt="slider-img" />
            </div>
          </Slider>
        </section>
        <section className="wrapper_expert_care spacing">
          <div className="container">
            <div className="page_title">
              <h2>Expert Care for Every Stage of Womanhood</h2>
              <p>
                Our goal is to make expert healthcare accessible, ensuring that
                every woman receives the attention, knowledge, and care she
                deserves. Because your well-being is not just a priority—it's
                our purpose.
              </p>
            </div>

            <Slider {...settings}>
              {/* {Array?.map((data) => ( */}
              <div className="wrap_expert_slider">
                <img className="expert_img" src={expertbg} alt="slider-img" />
                <div className="details_wrap_img">
                  <img
                    className="symtoms1"
                    src={expertdetails1}
                    alt="slider-img"
                  />
                  <img
                    className="symtoms"
                    src={expertdetails}
                    alt="slider-img"
                  />
                  <img
                    className="symtoms1"
                    src={expertdetails2}
                    alt="slider-img"
                  />
                </div>
              </div>
              <div className="wrap_expert_slider">
                <img className="expert_img" src={expertbg1} alt="slider-img" />
                <div className="details_wrap_img">
                  <img
                    className="symtoms1"
                    src={expertdetails3}
                    alt="slider-img"
                  />
                  <img
                    className="symtoms"
                    src={expertdetails4}
                    alt="slider-img"
                  />
                  <img
                    className="symtoms1"
                    src={expertdetails5}
                    alt="slider-img"
                  />
                </div>
              </div>
              <div className="wrap_expert_slider">
                <img className="expert_img" src={expertbg2} alt="slider-img" />
                <div className="details_wrap_img">
                  <img
                    className="symtoms1"
                    src={expertdetails6}
                    alt="slider-img"
                  />
                  <img
                    className="symtoms"
                    src={expertdetails7}
                    alt="slider-img"
                  />
                </div>
              </div>
              {/* ))} */}
            </Slider>
          </div>
        </section>
        <section className="wrapper_innovation spacing">
          <div className="container">
            <div className="page_title">
              <h2>
                Your Health, Our Priority <span></span> Powered by Innovation
              </h2>
              <p>
                Discover a seamless healthcare experience with advanced
                features, including easy appointment booking, virtual
                consultations, and personalized wellness plans.
              </p>
            </div>
            <div className="wrap_innovate">
              <div className="wrap_left">
                <span>01</span>
                <h3>Support Through Every Stage</h3>
                <p>
                  Our app is designed to assist women in tracking and managing
                  four major health concerns—PCOS, Endometriosis, Menopause, and
                  Postpartum. We provide continuous support and insights to help
                  you navigate every phase of your health journey.
                </p>
              </div>
              <div className="wrap_right">
                <img src={healthmeter} alt="health-care-img" />
              </div>
            </div>
            <div className="wrap_innovate">
              <div className="wrap_left">
                <span>02</span>
                <h3>Advanced Period Tracker</h3>
                <p>
                  Stay on top of your cycle with our detailed period tracker.
                  Log your cycle days, track your flow, monitor symptoms, and
                  record changes in mood, pain levels, and weight—all in one
                  place.
                </p>
              </div>
              <div className="wrap_right">
                <img src={healthmeter1} alt="health-care-img" />
              </div>
            </div>
            <div className="wrap_innovate">
              <div className="wrap_left">
                <span>03</span>
                <h3>Instant Doctor Consultations</h3>
                <p>
                  Connect with expert doctors anytime, anywhere. Whether you
                  need advice, a diagnosis, or a treatment plan, our seamless
                  consultation feature ensures you get the right help when you
                  need it.
                </p>
              </div>
              <div className="wrap_right">
                <img src={healthmeter2} alt="health-care-img" />
              </div>
            </div>
          </div>
        </section>
        <section className="wrapper_total_care spacing">
          <div className="container">
            <div className="page_title">
              <h2>One App, Total Care</h2>
              <p>Your Health Journey Starts Here!</p>
            </div>
            <div className="wrap_cards">
              <div className="cstm_cards">
                <img src={totalcare} alt="expert-icon" />
                <h4>20+ Experts</h4>
                <p>Working across an in-house interdisciplinary team</p>
              </div>
              <div className="cstm_cards">
                <img src={totalcare1} alt="generation-icon" />
                <h4>3 Generations</h4>
                <p>
                  With each one smarter, lighter, and more durable than the last
                </p>
              </div>
              <div className="cstm_cards">
                <img src={totalcare2} alt="members-icon" />
                <h4>6k+ Members</h4>
                <p>Trust HolyPills for their health concerns and well-being</p>
              </div>
            </div>
          </div>
        </section>
        <section className="wrapper_Features spacing">
          <div className="container">
            <div className="page_title">
              <h2>Features</h2>
              <p>
                Discover a seamless healthcare experience with advanced
                features, including easy appointment booking, virtual
                consultations, and personalized wellness plans.
              </p>
            </div>
            <div className="blog_list">
              {blogList &&
                blogList.map((item) => {
                  return (
                    <div
                      key={item.id}
                      className={`blog_item ${
                        activeIndex === item.id ? "active" : ""
                      }`}
                      onMouseEnter={() => setActiveIndex(item.id)}
                    >
                      <div className="content">
                        <span>{item.title}</span>
                        <p>{item.Description}</p>
                      </div>
                      <div className="blog_img">
                        <img src={item.img} alt="blog-img" />
                      </div>
                    </div>
                  );
                })}
            </div>
            {/* <div className="pcos_cards_hover">
            <div className="cards_animate">
              <div className="wrap_left">
                <span>PCOS</span>
                <p>
                  It is one of the most common causes of infertility but can be
                  managed with lifestyle changes, medication, and proper
                  monitoring.
                </p>
              </div>
              <div className="wrap_right">
                <img src={features1} alt="" />
              </div>
            </div>
            <div className="cards_animate">
              <div className="wrap_left">
                <span>PCOS</span>
                <p>
                  It is one of the most common causes of infertility but can be
                  managed with lifestyle changes, medication, and proper
                  monitoring.
                </p>
              </div>
              <div className="wrap_right">
                <img src={features2} alt="" />
              </div>
            </div>
            <div className="cards_animate">
              <div className="wrap_left">
                <span>PCOS</span>
                <p>
                  It is one of the most common causes of infertility but can be
                  managed with lifestyle changes, medication, and proper
                  monitoring.
                </p>
              </div>
              <div className="wrap_right">
                <img src={features3} alt="" />
              </div>
            </div>
            <div className="cards_animate">
              <div className="wrap_left">
                <span>PCOS</span>
                <p>
                  It is one of the most common causes of infertility but can be
                  managed with lifestyle changes, medication, and proper
                  monitoring.
                </p>
              </div>
              <div className="wrap_right">
                <img src={features4} alt="" />
              </div>
            </div>
          </div> */}
          </div>
        </section>
      </div>
    </>
  );
};

export default AboutUs;
